import script from "./ProjectInvestModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectInvestModal.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectInvestModal.vue?vue&type=style&index=0&id=9df69f38&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9df69f38"]])

export default __exports__